var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "用户申请id",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "userApplyId"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入用户申请id" },
                            model: {
                              value: _vm.model.userApplyId,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "userApplyId", $$v)
                              },
                              expression: "model.userApplyId"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "申请使用应用id",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "applicationId"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入申请使用应用id" },
                            model: {
                              value: _vm.model.applicationId,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "applicationId", $$v)
                              },
                              expression: "model.applicationId"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "用户审核状态",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "auditStatus"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入用户审核状态" },
                            model: {
                              value: _vm.model.auditStatus,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "auditStatus", $$v)
                              },
                              expression: "model.auditStatus"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "审核时间",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "auditTime"
                          }
                        },
                        [
                          _c("j-date", {
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请选择审核时间" },
                            model: {
                              value: _vm.model.auditTime,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "auditTime", $$v)
                              },
                              expression: "model.auditTime"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "审核人",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "auditor"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入审核人" },
                            model: {
                              value: _vm.model.auditor,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "auditor", $$v)
                              },
                              expression: "model.auditor"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "审核意见",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "auditRemark"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入审核意见" },
                            model: {
                              value: _vm.model.auditRemark,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "auditRemark", $$v)
                              },
                              expression: "model.auditRemark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }